export const MILLISECONDS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const SECONDS_PER_HOUR = MINUTES_PER_HOUR * SECONDS_PER_MINUTE; // 3600
export const MILLISECONDS_PER_HOUR = SECONDS_PER_HOUR * MILLISECONDS_PER_SECOND; // 3600000
export const HOURS_PER_DAY = 24;
export const SECONDS_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR * SECONDS_PER_MINUTE; // 86400
export const MILLISECONDS_PER_DAY = SECONDS_PER_DAY * MILLISECONDS_PER_SECOND; // 86400000
export const SECONDS_PER_QUARTER = 900;
export const QUARTERS_PER_HOUR = 4;
export const DAYS_PER_WEEK = 7;
export const SECONDS_PER_WEEK = SECONDS_PER_DAY * DAYS_PER_WEEK; // 604800
export const QUARTERS_PER_DAY = HOURS_PER_DAY * QUARTERS_PER_HOUR; // 96